import type { HTMLProps, LegacyRef } from 'react';
import { forwardRef } from 'react';

export interface NavItemProps extends HTMLProps<HTMLLIElement> {
  active?: boolean;
}

function NavItemComponent(
  { active = false, children, ...props }: NavItemProps,
  ref: LegacyRef<HTMLLIElement>
) {
  return (
    <li
      ref={ref}
      {...props}
      className={`nav-item ${active ? 'uk-active' : ''} ${
        props.className || ''
      }`}
    >
      {children}
    </li>
  );
}

export default forwardRef(NavItemComponent);
